module.exports = __webpack_public_path__ + "assets/media/2.28b3514f.wav";